import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field, FieldArray } from 'redux-form';
import PropTypes from 'prop-types';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { CustomDatePicker } from '../../../../../semantic-ui/components/custom-datepicker';
import { ModesComponent } from '../../modes-component';
import { normalizeInteger } from '../../../../../utils/normalizeInteger';
import { TnIcon, VolumeIcon } from '../../../../../components/text-icon';

export const CarFormView = ({
	trailersList,
	isTrailersListLoading,
	ownerships,
	isOwnershipsLoading,
	legals,
	isLegalsLoading,
	carTypes,
	isTypeDateIssueVisible,
	isTrailerVisible,
	isOwnershipVisible,
	modes,
	isCarTypesLoading,
	isModesLoading,
	isAvailableTrailers,
	onAddTrailerButtonClick,
}) => {
	return (
		<Grid className="car-form">
			<Grid.Row className="car-form__row">
				<Grid.Column width={5} className="car-form__column">
					Юр. лицо
				</Grid.Column>
				<Grid.Column width={9} className="car-form__column">
					<Field
						name="legal_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={legals}
						search
						dropdownClassName="static"
						loading={isLegalsLoading}
						disabled={isLegalsLoading}
						noResultsMessage="Юр. лица не найдены"
						placeholder="Выберите юр. лицо"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="car-form__row">
				<Grid.Column width={5} className="car-form__column">
					Модель
				</Grid.Column>
				<Grid.Column width={9} className="car-form__column">
					<Field
						name="name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите модель"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="car-form__row">
				<Grid.Column width={5} className="car-form__column">
					Гос. номер
				</Grid.Column>
				<Grid.Column width={9} className="car-form__column">
					<Field
						name="number"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите гос. номер"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="car-form__row">
				<Grid.Column width={5} className="car-form__column">
					Vin номер
				</Grid.Column>
				<Grid.Column width={9} className="car-form__column">
					<Field
						name="vin"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите vin номер"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="car-form__row">
				<Grid.Column width={5} className="car-form__column">
					Тип машины
				</Grid.Column>
				<Grid.Column width={9} className="car-form__column">
					<Field
						name="type_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={carTypes}
						search
						dropdownClassName="static"
						loading={isCarTypesLoading}
						disabled={isCarTypesLoading}
						noResultsMessage="Не найдено"
						placeholder="Выберите тип машины"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="car-form__row">
				<Grid.Column width={5} className="car-form__column">
					Год выпуска машины
				</Grid.Column>
				<Grid.Column width={3} className="car-form__column">
					<Field
						name="date_issue"
						type="text"
						component={CustomDatePicker}
						autoComplete="off"
						placeholder=". . / . . "
						dateFormat={['MM.yyyy', 'MM-yyyy', 'MM/yyyy']}
						showMonthYearPicker
					/>
				</Grid.Column>
			</Grid.Row>
			{isTypeDateIssueVisible && (
				<Grid.Row className="car-form__row">
					<Grid.Column width={5} className="car-form__column">
						Год выпуска рефрижератора
					</Grid.Column>
					<Grid.Column width={3} className="car-form__column">
						<Field
							name="type_date_issue"
							type="text"
							component={CustomDatePicker}
							autoComplete="off"
							placeholder=". . / . . "
							dateFormat={['MM.yyyy', 'MM-yyyy', 'MM/yyyy']}
							showMonthYearPicker
						/>
					</Grid.Column>
				</Grid.Row>
			)}
			<Grid.Row className="car-form__row">
				<Grid.Column width={5} className="car-form__column">
					Грузоподъемность
				</Grid.Column>
				<Grid.Column width={9} className="car-form__column">
					<Field
						name="weight"
						type="text"
						normalize={normalizeInteger}
						component={FormInputField}
						autoComplete="off"
						icon={TnIcon}
						placeholder="Укажите грузоподъемность"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="car-form__row">
				<Grid.Column width={5} className="car-form__column">
					Вместимость
				</Grid.Column>
				<Grid.Column width={9} className="car-form__column">
					<Field
						name="volume"
						type="text"
						normalize={normalizeInteger}
						component={FormInputField}
						autoComplete="off"
						icon={VolumeIcon}
						placeholder="Укажите вместимость"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="car-form__row">
				<Grid.Column width={5} className="car-form__column">
					Тип владения
				</Grid.Column>
				<Grid.Column width={9} className="car-form__column">
					<Field
						name="ownership_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={ownerships}
						search
						dropdownClassName="static"
						loading={isOwnershipsLoading}
						disabled={isOwnershipsLoading}
						noResultsMessage="Не найдено"
						placeholder="Выберите тип владения"
						isWithoutSelectOnBlur
					/>
				</Grid.Column>
			</Grid.Row>
			{isOwnershipVisible && (
				<>
					<Grid.Row className="car-form__row">
						<Grid.Column width={5} className="car-form__column">
							Название документа
						</Grid.Column>
						<Grid.Column width={9} className="car-form__column">
							<Field
								name="doc_name"
								type="text"
								component={FormInputField}
								autoComplete="off"
								placeholder="Укажите название документа"
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="car-form__row">
						<Grid.Column width={5} className="car-form__column">
							Номер документа
						</Grid.Column>
						<Grid.Column width={9} className="car-form__column">
							<Field
								name="doc_number"
								type="text"
								component={FormInputField}
								autoComplete="off"
								placeholder="Укажите номер документа"
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="car-form__row">
						<Grid.Column width={5} className="car-form__column">
							Дата выдачи документа
						</Grid.Column>
						<Grid.Column width={9} className="car-form__column">
							<Field
								name="doc_date"
								type="text"
								component={CustomDatePicker}
								autoComplete="off"
								placeholder=". . / . . / . . . ."
								dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
							/>
						</Grid.Column>
					</Grid.Row>
				</>
			)}
			{isTrailerVisible && (
				<Grid.Row className="car-form__row">
					<Grid.Column width={5} className="car-form__column">
						Прицеп по умолчанию
					</Grid.Column>
					<Grid.Column width={9} className="car-form__column">
						<div
							className={
								isAvailableTrailers ? 'car-form__column-with-button' : ' car-form__column_with-select'
							}
						>
							<div className={`car-form__field-with-${isAvailableTrailers ? 'button' : 'select'}`}>
								<Field
									name="trailer"
									type="text"
									component={FormSelectField}
									autoComplete="off"
									options={trailersList}
									search
									dropdownClassName="static"
									loading={isTrailersListLoading}
									disabled={isTrailersListLoading}
									noResultsMessage="Не найдено"
									placeholder="Выберите прицеп по умолчанию"
								/>
							</div>
							{isAvailableTrailers && (
								<div className="car-form__add-button" onClick={onAddTrailerButtonClick} />
							)}
						</div>
					</Grid.Column>
				</Grid.Row>
			)}
			{isTypeDateIssueVisible && (
				<FieldArray name="modes" component={ModesComponent} props={{ modes, isModesLoading }} />
			)}
		</Grid>
	);
};

CarFormView.propTypes = {
	trailersList: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			key: PropTypes.string.isRequired,
		}),
	),
	isTrailersListLoading: PropTypes.bool.isRequired,
	onAddTrailerButtonClick: PropTypes.func.isRequired,
	isCarInfoLoading: PropTypes.bool.isRequired,
	isOwnershipsLoading: PropTypes.bool,
	ownerships: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	legals: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isLegalsLoading: PropTypes.bool.isRequired,
	carTypes: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isTypeDateIssueVisible: PropTypes.bool.isRequired,
	isTrailerVisible: PropTypes.bool.isRequired,
	isOwnershipVisible: PropTypes.bool,
	modes: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isCarTypesLoading: PropTypes.bool.isRequired,
	isModesLoading: PropTypes.bool.isRequired,
	isAvailableTrailers: PropTypes.bool.isRequired,
};
